module.exports = __webpack_public_path__ + "menu.svg?68befbe53c20d739fa0a2a6ea20b7613";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.svg
// module id = 248
// module chunks = 0